// extracted by mini-css-extract-plugin
export var container = "FigureAlt-module--container--VwTSI";